import React from 'react'
import DoctorVideoCall from '../../components/DoctorVideoCall/DoctorVideoCall'

function DoctorVideoCallPage() {
  return (
    <DoctorVideoCall/>
  )
}

export default DoctorVideoCallPage